import { ChangeEvent } from 'react';

export const validateInput = (
  rules: { [key: string]: string | number | boolean },
  value:
    | string
    | number
    | boolean
    | ChangeEvent<HTMLInputElement>
    | undefined
    | null
    | FileList
    | string[]
) => {
  let validationResponse = { isValid: true, error: '' };

  if (typeof value === 'undefined') {
    if (rules.required) {
      return { isValid: false, error: 'Required' };
    }
  }

  if (typeof value === 'string') {
    if (rules.type !== typeof value) {
      return { isValid: false, error: 'Invalid value type' };
    }
    if (rules.required && value.trim() === '') {
      return { isValid: false, error: 'Required' };
    }
    if (value.length < rules.minLength) {
      return {
        isValid: false,
        error: `Must be greater than ${rules.minLength} characters.`,
      };
    }
    if (value.length > rules.maxLength) {
      return {
        isValid: false,
        error: `Must be less than or equal to ${rules.maxLength} characters.`,
      };
    }
  }

  if (typeof value === 'number') {
    if (value > rules.max) {
      return {
        isValid: false,
        error: `Must be less than or equal to ${rules.max}`,
      };
    }
    if (value < rules.min) {
      return {
        isValid: false,
        error: `Must be greater than ${rules.min}`,
      };
    }
    if (rules.isInteger && !Number.isInteger(value)) {
      return {
        isValid: false,
        error: `Must be a integer number.`,
      };
    }
    if (value.toString().length < rules.minLength) {
      return {
        isValid: false,
        error: `Must be greater than ${rules.minLength} characters.`,
      };
    }
    if (value.toString().length > rules.maxLength) {
      return {
        isValid: false,
        error: `Must be less than or equal to ${rules.maxLength} characters.`,
      };
    }
  }

  if (typeof value === 'boolean') {
    return validationResponse;
  }

  if (typeof value === 'object' && Array.isArray(value)) {
    if (value.length < rules.minLength && rules.required) {
      return { isValid: false, error: 'Required' };
    }
  }

  return validationResponse;
};
